import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/airplay.vue
var o = {
	name: "DtIconAirplay",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--airplay"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Airplay",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M2 2a.5.5 0 0 0-.5.5v5A.5.5 0 0 0 2 8h.5a.5.5 0 0 1 0 1H2A1.5 1.5 0 0 1 .5 7.5v-5A1.5 1.5 0 0 1 2 1h8a1.5 1.5 0 0 1 1.5 1.5v5A1.5 1.5 0 0 1 10 9h-.5a.5.5 0 0 1 0-1h.5a.5.5 0 0 0 .5-.5v-5A.5.5 0 0 0 10 2H2Z",
		"clip-rule": "evenodd"
	}, null, -1), r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M6 7a.5.5 0 0 1 .384.18l2.5 3A.5.5 0 0 1 8.5 11h-5a.5.5 0 0 1-.384-.82l2.5-3A.5.5 0 0 1 6 7Zm-1.432 3h2.864L6 8.281 4.568 10Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=airplay.js.map